import { useGlobalContext } from '@/context/Global/GlobalContext';
import { DashboardUserType } from '@/utils/enums';
import { ADMIN_ROLES, adminHasRole, Session } from '@/utils/session/model';
import { produce, WritableDraft } from 'immer';
import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useImmer } from 'use-immer';
import {
  ADMIN_MENU_OPTIONS,
  SELLER_MENU_OPTIONS,
  SideNavigationOptionUi,
} from './SideNavigationOptionsUi';

export function useSideNavigationOptionsViewController() {
  const location = useLocation();
  const [uiState, setUiState] = useImmer<SideNavigationOptionUi[]>([]);

  const { session } = useGlobalContext();

  useEffect(() => {
    if (!session) return;
    const menuItems = getMenu(session);
    const updatedExpaned = produce(menuItems, (draft) => {
      determineCollapsedState(draft);
    });

    setUiState(updatedExpaned);
  }, [session, location]);

  const determineCollapsedState = (
    optionsTree: WritableDraft<SideNavigationOptionUi[]>
  ) => {
    for (const option of optionsTree) {
      option.expanded = !!matchPath(
        { path: option.to, end: false },
        location.pathname
      );
      if (option.children && option.children.length > 0) {
        determineCollapsedState(option.children);
      }
    }
  };

  return {
    uiState,
    actions: {},
  };
}

function getMenu(session: Session): SideNavigationOptionUi[] {
  if (session.type === DashboardUserType.SELLER) return SELLER_MENU_OPTIONS;
  if (session.type === DashboardUserType.ADMIN) {
    if (adminHasRole(session, ADMIN_ROLES.DISBURSEMENT_MANAGMENT)) {
      return ADMIN_MENU_OPTIONS;
    } else {
      return ADMIN_MENU_OPTIONS.filter(
        (option) => option.id !== 'payment-balance'
      );
    }
  }
  return [];
}
